import { useEffect, useState } from "react";

export default function Splash({ onDone }) {
  const [exit, setExit] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setExit(true), 1100);
    const t2 = setTimeout(() => onDone?.(), 1700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onDone]);

  return (
    <div
      data-testid="splash-screen"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-sand-900"
      style={{
        opacity: exit ? 0 : 1,
        pointerEvents: exit ? "none" : "auto",
        transition: "opacity 600ms cubic-bezier(0.25,0.1,0.25,1)",
      }}
    >
      <div className="flex flex-col items-center" style={{ animation: "fade-up 0.7s cubic-bezier(0.25,0.1,0.25,1) both" }}>
        <img
          src="https://customer-assets.emergentagent.com/job_tastebuds-hub/artifacts/2vjwnbkm_Tastbuds%20Food%20Network%20Logo.png"
          alt="Tastebuds Food Network"
          className="w-44 h-44 object-contain"
        />
        <div className="mt-4 font-mono text-[10px] tracking-[0.4em] uppercase text-ochre-400">
          Where Food, Culture & Community Meet
        </div>
      </div>
    </div>
  );
}
